import { styled } from 'goober';

export const SearchWrapper = styled('div')`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;

    & > :first-child {
        flex-shrink: 0;
        width: 325px !important;
    }

    & > button {
        min-width: unset !important;
    }
`;
